import { CSSProperties, RefObject, useEffect, useState } from 'react';

type Fit = 'contain' | 'cover' | 'width' | 'height';

export const useScaleCanvas = (
  ref: RefObject<HTMLElement | null>,
  canvasW: number,
  canvasH: number,
  fit: Fit = 'contain',
) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new ResizeObserver(([entry]) => {
      const sw = entry.contentRect.width / canvasW;
      const sh = entry.contentRect.height / canvasH;
      setScale(
        fit === 'width' ? sw
        : fit === 'height' ? sh
        : fit === 'cover' ? Math.max(sw, sh)
        : Math.min(sw, sh),
      );
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, canvasW, canvasH, fit]);

  const wrapperStyle: CSSProperties = {
    position: 'relative',
    width: canvasW * scale,
    height: canvasH * scale,
  };

  const canvasStyle: CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: canvasW,
    height: canvasH,
    transformOrigin: 'top left',
    transform: `scale(${scale})`,
  };

  return { scale, wrapperStyle, canvasStyle };
};
